import React from 'react';
import PropTypes from 'prop-types';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { PER_NIGHT, FROM_PRICE_PER_PERIOD } from "../../../utils/default-strings";
import { Heading } from "../../typography/Heading";
import { getPricePerPeriodAndRatingMarkup } from "./utils/getPricePerPeriodAndRatingMarkup";
import { getPricePerPeriodAndLocationMarkup } from "./utils/getPricePerPeriodAndLocationMarkup";
export var Component = function Component(_ref) {
  var areOnlyNightPriceAndRatingDisplayed = _ref.areOnlyNightPriceAndRatingDisplayed,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      locationName = _ref.locationName,
      periodText = _ref.periodText,
      pricePerPeriod = _ref.pricePerPeriod,
      pricePerPeriodPrefix = _ref.pricePerPeriodPrefix,
      propertyName = _ref.propertyName,
      ratingNumber = _ref.ratingNumber;
  return React.createElement(Segment.Group, {
    className: "is-summary",
    compact: true
  }, !areOnlyNightPriceAndRatingDisplayed && React.createElement(Segment, null, React.createElement(Heading, null, propertyName)), React.createElement(Segment.Group, {
    className: "horizontal-wrap",
    horizontal: !areOnlyNightPriceAndRatingDisplayed
  }, areOnlyNightPriceAndRatingDisplayed ? getPricePerPeriodAndRatingMarkup(isShowingPlaceholder, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber) : getPricePerPeriodAndLocationMarkup(isShowingPlaceholder, locationName, periodText, pricePerPeriod, pricePerPeriodPrefix, ratingNumber)));
};
Component.displayName = 'Summary';
Component.defaultProps = {
  areOnlyNightPriceAndRatingDisplayed: false,
  isShowingPlaceholder: false,
  periodText: PER_NIGHT,
  pricePerPeriod: '',
  pricePerPeriodPrefix: FROM_PRICE_PER_PERIOD,
  ratingNumber: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  areOnlyNightPriceAndRatingDisplayed: PropTypes.bool,
  isShowingPlaceholder: PropTypes.bool,
  locationName: PropTypes.string.isRequired,
  periodText: PropTypes.string,
  pricePerPeriod: PropTypes.string,
  pricePerPeriodPrefix: PropTypes.string,
  propertyName: PropTypes.string.isRequired,
  ratingNumber: PropTypes.number
} : {};